<section>
  @if (type === "card") {
    <div class="bg-b flex flex-row flex-wrap gap-4">
      @for (category of categoryList; track $index) {
        <button
          class="flex h-[200px] w-[221px] flex-col gap-2 rounded-lg border border-greyscale-100 p-4 shadow-lg"
          (click)="handleClick($index)"
          [ngClass]="{
            'border-primary-300': isSelected($index),
            'border-4': isSelected($index),
            'shadow-lg': shadow,
          }"
        >
          <div class="m-auto rounded-full bg-primary-50 p-4 text-primary-500">
            <lucide-icon [name]="category.icon" [size]="32" />
          </div>
          <h4 class="text-primary-900">
            {{ category.label }}
            @if (category.tooltipMessage) {
              <app-tooltip-icon
                position="top"
                [message]="category.tooltipMessage"
              />
            }
          </h4>
          <p class="text-center text-paragraph-s-reg text-greyscale-700">
            {{ category.description }}
          </p>
        </button>
      }
    </div>
  }
  @if (type === "list") {
    <div class="flex flex-row flex-wrap gap-4">
      @for (category of categoryList; track $index) {
        <button
          class="flex min-w-[150px] flex-1 flex-row items-start justify-start gap-2 rounded-lg border border-greyscale-100 p-4 shadow-lg"
          (click)="handleClick($index)"
          [ngClass]="{
            'border-primary-300': isSelected($index),
            'border-4': isSelected($index),
            'shadow-lg': shadow,
          }"
        >
          @if (category.icon) {
            <div class="rounded-full bg-primary-50 p-2 text-primary-500">
              <lucide-icon [name]="category.icon" [size]="24" />
            </div>
          }
          <div class="flex flex-col pt-2">
            <h4 class="text-left text-primary-900">
              {{ category.label }}
              @if (category.tooltipMessage) {
                <app-tooltip-icon
                  position="top"
                  [message]="category.tooltipMessage"
                />
              }
            </h4>
            <p class="text-left text-paragraph-s-reg text-greyscale-700">
              {{ category.description }}
            </p>
          </div>
        </button>
      }
    </div>
  }
  @if (type === "scroll") {
    <div
      class="flex max-h-[250px] flex-col gap-1 overflow-y-scroll rounded-lg border border-greyscale-200 bg-primary-50 p-2"
    >
      @for (category of categoryList; track $index) {
        <button
          class="flex min-w-[150px] flex-1 flex-row items-start justify-start gap-2 rounded-lg border p-2 shadow-lg"
          (click)="handleClick($index)"
          [ngClass]="{
            'border-greyscale-200 bg-white': !isSelected($index),
            'border-primary-300 bg-primary-100': isSelected($index),
            'shadow-lg': shadow,
          }"
        >
          @if (category.icon) {
            <div class="rounded-full bg-primary-50 p-2 text-primary-500">
              <lucide-icon [name]="category.icon" [size]="24" />
            </div>
          }
          <div class="flex flex-col pt-2">
            <p class="text-left text-paragraph-med text-primary-900">
              {{ category.label }}
              @if (category.tooltipMessage) {
                <app-tooltip-icon
                  position="top"
                  [message]="category.tooltipMessage"
                />
              }
            </p>
            <p class="text-left text-paragraph-s-reg text-greyscale-700">
              {{ category.description }}
            </p>
          </div>
        </button>
      }
    </div>
  }
</section>
